import type { DTOFileInfo } from 'src/apis/dto/DTOFileInfo';

export const enum Screen {
  MATCH = 'MATCH',
  MIRROR = 'MIRROR',
}

export const enum ScreeningTarget {
  SELF = 'SELF',
  PEER = 'PEER',
}

export const enum ScreeningContentType {
  IMAGE = 'IMAGE',
}

export interface UploadServerScreeningContentRequest {
  screen: Screen;
  matchId?: string;
  contentType: ScreeningContentType;
  target: ScreeningTarget;
  fileInfo: DTOFileInfo;
}
